<template>
  <div class="widget-index">
    <div class="header-bar">
      <router-link
        :to="{ name: 'location-webhooks-show', params: { webhookId: 'new' } }"
        tag="button"
      >{{ $t('New Webhook') }}</router-link>
    </div>

    <div class="empty f-body tc w-60 center fill-geyser fadeIn animated" v-if="noWebhooks">
      <UIIcon name="no-results" class="dib mv5" style="width:8rem;" />
          <router-link
            class="link-style"
            :to="{ name: 'location-webhooks-show', params: { webhookId: 'new' } }"
          >{{ $t('New Webhook') }}</router-link>
    </div>

    <UIRowIndexLoader v-if="isLoading" />

    <div v-if="!isLoading" class="widgetgrid animated fadeIn">
      <div class="widgetcard" v-for="webhook in webhooks" :key="webhook.id">
        <div class="title f4 nowrap dib truncate slate w">
          {{ titleWebhook(webhook.event_type) }} <br /><small style="font-size: 12px; font-weight: 200"> {{ webhook.url }}</small>
        </div>
        <UIButton
          tiny
          icon="edit"
          :to="{ name: 'location-webhooks-show', params: { webhookId: webhook.id } }"
        >{{ $t("edit") }}</UIButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIButton from '@/core/shared/components/ui/UIButton';
import UIInput from '@/core/shared/components/ui/UIInput';
import UIIcon from '@/core/shared/components/ui/UIIcon';
import UIRowIndexLoader from '@/core/shared/components/ui/UIRowIndexLoader';

@Component({
  props: {
    locationId: {
      type: String,
      required: true,
    },
  },
  components: {
    UIButton,
    UIInput,
    UIIcon,
    UIRowIndexLoader,
  },
})
export default class webhookIndex extends Vue {
  share = null;
  clipboard = null;

  get isLoading () {
    return this.$store.state.webhooks.isFetchingWebhooks && this.webhooks.length === 0;
  }

  get noWebhooks () {
    return !this.$store.state.webhooks.isFetchingWebhooks && this.webhooks.length === 0;
  }

  get webhooks () {
    return this.$store.getters['entities/Webhook']((webhook) => webhook.location_id === this.locationId);
  }

  created () {
    this.$store.commit('setTitle', this.$t('Webhooks'));
  }

  mounted () {
    this.$store.dispatch('getLocationWebhooks', this.locationId);
  }

  beforeDestroy () {
    if (this.clipboard) this.clipboard.destroy();
  }

  titleWebhook (event) {
    switch (event) {
    case 'booking.create':
      return this.$t('Booking Created');
    case 'booking.update':
      return this.$t('Booking Updated');
    case 'booking.delete':
      return this.$t('Booking Deleted');
    default:
      return event;
    }
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.widget-index {
  @apply --container;

  & .header-bar {
    margin: var(--spacingMd) 0 var(--spacingSm) 0;
    text-align: right;

    @media (--desktop) {
      margin: var(--spacingMd) 0;
    }

    & button {
      @apply --buttonPrimary;

      display: inline-block;
      width: auto;
    }
  }

  & h2 {
    @apply --f3;
  }

  & .widgetgrid {
    display: grid;
    grid-gap: var(--spacingSm);

    & .widgetcard {
      background-color: var(--colorWhite);
      box-shadow: var(--shadowSm);
      border-radius: var(--radius);

      display: grid;
      grid-template-columns: auto 5.5rem 5.5rem;
      align-items: center;
      grid-gap: var(--spacingSm);
      padding: var(--spacingSm);

      @media (--tablet) {
        grid-gap: var(--spacingMd);
        padding: var(--spacingAltSm) var(--spacingAltMd);
      }
    }
  }

  & .share-modal .main-content {
    padding: var(--spacingMd);
    display: grid;
    grid-gap: var(--spacingMd);

    & .embed,
    & .link {
      display: grid;
      grid-gap: var(--spacingSm);

      & >>> button {
        justify-self: start;
      }
    }

    & h1 {
      @apply --f3;
    }

    & h2 {
      @apply --f4;
    }

    & p {
      @apply --f5;
    }
  }
}
</style>
